import { usePathname } from 'next/navigation';
import { PUBLIC_ROUTES } from '@/configs/routes';

export default function useIsPublicSearch() {
  const pathname = usePathname();
  return pathname.includes(PUBLIC_ROUTES.SEARCH);
}
